<template>
    <div v-if="preScoring && preScoring.Scoring && !loading">
        <v-dialog v-model="dialog" width="500" >
            <v-card>
                <v-card-title class="text-h5  lighten-2" style="background: #25ccd5; color:white;">
                Bienvenido de nuevo
                </v-card-title>

                <v-card-text style="padding: 30px 24px 20px;">
                Bienvenido de nuevo. Por favor, acepta las condiciones y clica en  Quiero Ofertas para acceder a tu área privada
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    @click="dialog = false"
                >
                    Aceptar
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <template v-if="preScoring.source != 'comprarcasa' && (preScoringWarnings && preScoringWarnings.code && preScoringWarnings.code === 'success') || (preScoringWarnings==null && preScoring.Scoring.code === 'success')">
            <ScoringSuccess/>
        </template>
        
        <template v-if="preScoring.source != 'comprarcasa' && (preScoringWarnings && preScoringWarnings.code && preScoringWarnings.code === 'rejected') || (preScoringWarnings==null && preScoring.Scoring.code === 'rejected')">
            <NotViable @reScoring="recalculateScoring" />
        </template>

        <template v-if="preScoring.source == 'comprarcasa'">
            <SuccessOnlyMessage/>
        </template>
    </div>
    <div v-else class="d-flex justify-center">
        <div style="width: 65%; margin-top: 50px" >
            <v-row>
                <v-col cols="6">
                    <v-skeleton-loader  type="article"></v-skeleton-loader> 
                </v-col>
                <v-col cols="6">
                    <v-skeleton-loader  type="table-heading, actions" ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6">
                    <v-skeleton-loader  type="image"></v-skeleton-loader> 
                </v-col>
                <v-col cols="6">
                    <v-skeleton-loader  type="image"></v-skeleton-loader> 
                </v-col>
            </v-row>
                <v-row>
                <v-col cols="6">
                </v-col>
                <v-col cols="6">
                    <v-skeleton-loader  type="list-item-three-line"></v-skeleton-loader> 
                    <v-skeleton-loader  type="list-item-three-line"></v-skeleton-loader> 
                    <v-skeleton-loader  type="actions" ></v-skeleton-loader>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations, mapActions } from 'vuex';
    import ScoringSuccess from '../components/scoring/ScoringSuccess';
    import NotViable from '../components/scoring/NotViable';
    import SuccessOnlyMessage from '../components/scoring/SuccessOnlyMessage';
    import goTo from 'vuetify/es5/services/goto'

    export default {
        components:{
            ScoringSuccess,
            NotViable,
            SuccessOnlyMessage
        },
        watch: { 
            initalDataLoaded: function(newVal, oldVal) { 
                if(oldVal === false && newVal === true){
                    this.initSuccess();
                }
            }
        },
        computed: {
            ...mapState([
                'initalDataLoaded',
                'preScoringWarnings',
                'preScoring',
                'loading',
                'token_id',
                'initalDataLoaded',
                'accesibleViews',
                'showIframe',
                'disable_buttons_success'
            ])
        },
        data() {
            return {
                dialog:false 
            }
        },
        mounted() {
            if(this.$route.query.token_id){
                this.SET_SHOW_IFRAME( this.$route.query.iframe);
               setTimeout(() => this.test_prescoring(), 2000); 
            }else{
                this.test_prescoring()
            }

        },
        methods: {
            initSuccess() {
                if(this.preScoring.Scoring.code === 'rejected' && this.preScoring.Vivienda.tipo_vivienda == 'habitual'){
                    
                    this.SET_LOADING(true);
                    this.CHANGE_ACTIVE_PRODUCT('compra_vivienda_100');
                    this.saveProduct({token:this.token_id, lead_type:"3"})
                        .then(()=>{
                            this.calculateScoring()
                                .then(response=>{
                                    this.SET_LOADING(false);
                                    this.SET_PRESCORING_DATA(response.data.data.PreScoring);
                                    if(this.showIframe){
                                        this.SET_PRESCORING_WARNINGS(response.data.data.prescoring_warnings);
                                        this.preScoringWarnings.code=response.data.data.prescoring_warnings.code;
                                    }
                                    
                                })
                        })
                }
            },
            test_prescoring(){
                if(this.initalDataLoaded && this.accesibleViews.includes('success')){
                    this.SET_ACTIVE_STEP(4);
                    this.SET_LOADING(false);
                    goTo(0, {offset:60});
                    if(this.initalDataLoaded){
                        this.initSuccess();
                        if(this.$route.query.modal_welcome=='true'){
                            this.dialog = true;
                        }
                    }
                }else{
                    this.$router.push('/view3');
                }
            },
            recalculateScoring(type){
                this.SET_LOADING(true);

                switch (type) {
                    case 'personal':
                        this.sendPersoanlLoans(this.preScoring.Vivienda.prestamo_personal,this.preScoring.Vivienda.observaciones)
                            .then(response=>{
                                this.SET_LOADING(false);
                                this.SET_PRESCORING_DATA(response.data.data.PreScoring);
                                this.SET_PRESCORING_WARNINGS(response.data.data.prescoring_warnings);
                                this.preScoringWarnings.code=response.data.data.prescoring_warnings.code;
                                if(response.data.data.PreScoring.Scoring.actions[0].endpoint){
                                    this.SET_LOADING(true);
                                    this.callUrlFromResponse(response.data.data.PreScoring.Scoring.actions[0].endpoint)
                                        .then(response =>{
                                            this.SET_LOADING(false);
                                        })
                                }
                            }).catch(error=>{
                                this.SET_LOADING(false);
                                console.log('Error: ' , error);
                            })
                        break;
                
                    case 'owner':
                    case 'deuda':
                        this.calculateScoring({token: this.token_id, lead_type:"3", calculate:1})
                            .then(response => {
                                this.SET_LOADING(false);
                                this.SET_PRESCORING_DATA(response.data.data.PreScoring);
                                this.SET_PRESCORING_WARNINGS(response.data.data.prescoring_warnings);
                                this.preScoringWarnings.code=response.data.data.prescoring_warnings.code;
                            })
                        break;
                    default:
                        this.saveProduct({token: this.token_id, lead_type:"3", calculate:1})
                            .then(response => {
                                this.SET_LOADING(false);
                                this.SET_PRESCORING_DATA(response.data.data.PreScoring);
                                this.SET_PRESCORING_WARNINGS(response.data.data.prescoring_warnings);
                                this.preScoringWarnings.code=response.data.data.prescoring_warnings.code;
                            })
                        break;
                }         
            },
            ...mapMutations([
                'SET_LOADING',
                'SET_ACTIVE_STEP',
                'CHANGE_ACTIVE_PRODUCT',
                'SET_PRESCORING_DATA',
                'SET_PRESCORING_WARNINGS',
                'SET_SHOW_IFRAME',
                'SET_DISABLE_BUTTONS_SUCCESS'
            ]),
            ...mapActions([
                'calculateScoring',
                'saveProduct',
                'calculateScoring',
                'sendPersoanlLoans',
                'callUrlFromResponse'
            ]),
        }
    }
</script>

<style lang="scss" scoped>
    .header_success{
        h2{
            color: #FFF;
        }
    }
</style>